<div class="container">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode() }">
    <form [formGroup]="filterForm">
      <div class="row">
        <div class="col">
          <app-custom-date-picker
            [label]="'From Date:'"
            [controlname]="this.filterForm.controls['from_date']"
          ></app-custom-date-picker>
        </div>
        <div class="col">
          <app-custom-date-picker
            [label]="'To Date:'"
            [controlname]="this.filterForm.controls['to_date']"
          ></app-custom-date-picker>
        </div>
        <div class="col">
          <app-custom-dropdown
            [label]="'Condition:'"
            [items]="conditionOptions"
            [controlname]="this.filterForm.controls['condition']"
          ></app-custom-dropdown>
        </div>
        <div class="filterBtn col-md1">
          <button
            class="btn btn-light hover-button apply"
            (click)="clearClick()"
          >
            <mat-icon>clear_all</mat-icon>
            <span>Clear Filter</span>
          </button>
        </div>
        <div class="filterBtn">
          <button
            class="btn btn-light hover-button apply"
            (click)="filterClick()"
          >
            <mat-icon>filter_list</mat-icon>
            <span>Apply Filter</span>
          </button>
        </div>
      </div>
    </form>
  </div>
  <br />
  <h2 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
    Vessel View Table
  </h2>
  <div class="table-container scroll-bar">
    <table
      class="mat-elevation-z8"
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead>
        <tr>
          <th mat-sort-header="sNo" rowspan="2">S.No</th>
          <th class="fixed-head" mat-sort-header="shipName" rowspan="2">
            Ship
          </th>
          <th mat-sort-header="segment" rowspan="2">Segment</th>
          <th mat-sort-header="voyNumber" rowspan="2">Voyage Number</th>
          <th mat-sort-header="condition" rowspan="2">Condition</th>
          <th colspan="4">Ports</th>
          <th rowspan="2">Instructed Speed <br />(kts)</th>
          <th rowspan="2">CP Consumption <br />(mt/day)</th>
          <th rowspan="2">Good Wx<br />Performance Speed <br />(kts)</th>
          <th rowspan="2">Voyage<br />Average Speed <br />(kts)</th>
          <th colspan="3">Good Wx Daily Consumption(mt/day)</th>
          <th rowspan="2">Good Wx %</th>
          <th rowspan="2">Good Wx Dist <br />(nm)</th>
          <th rowspan="2">Voyage Duration <br />(Hours)</th>
          <th rowspan="2">Voyage Distance <br />(nm)</th>
          <th rowspan="2">Total Bunker Consumption <br />(mt/day)</th>
          <th rowspan="2">Average Daily Consumption <br />(mt/day)</th>
          <th rowspan="2" class="time">
            <span class="info">
              Time(Hrs)<mat-icon
                class="info"
                matTooltip="loss in red gain in green"
                >info</mat-icon
              ><br />
              Lost(-) or Gained(+)</span
            >
          </th>
          <th colspan="3">
            <span class="header-show info1">
              Bunker Lost(-) or Gained(mt)<mat-icon
                class="info"
                matTooltip="loss in red gain in green"
                >info</mat-icon
              >
            </span>
          </th>
          <th colspan="2">Claim Estimate</th>
          <th rowspan="2"><span>Claimable Amout($)</span></th>
          <th rowspan="2">
            <span class="info2"
              >Report<mat-icon class="info" matTooltip="reports upto 90 days"
                >info</mat-icon
              ></span
            >
          </th>
        </tr>
        <tr>
          <th><span>From</span></th>
          <th><span>To</span></th>
          <th>
            <span>From/COSP <br />(Date & UTC time)</span>
          </th>
          <th>
            <span>To/EOSP <br />(Date & UTC time)</span>
          </th>
          <th><span>HSFO</span></th>
          <th><span>VLSFO</span></th>
          <th><span>GO</span></th>
          <th><span>HSFO</span></th>
          <th><span>VLSFO</span></th>
          <th><span>GO</span></th>
          <th><span>Daily Hire($) </span></th>
          <th><span>Avg Bunker Price</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td>{{ element.sNo }}</td>
          <td class="fixed-col">
            {{ element.shipName }}
          </td>

          <td>{{ element.segment }}</td>
          <td>{{ element.voyNumber }}</td>
          <td>{{ element.condition }}</td>
          <td>{{ element.from }}</td>
          <td>{{ element.to }}</td>
          <td>{{ element.fromDate }}</td>
          <td>{{ element.toDate }}</td>
          <td>{{ element.instructedSpd }}</td>
          <td>{{ element.cpConsumption }}</td>
          <td>{{ element.goodWxPerSpd }}</td>
          <td>{{ element.voyAvgSpd }}</td>
          <td>{{ element.goodWxDailyConsp.HSFO }}</td>
          <td>{{ element.goodWxDailyConsp.VLSFO }}</td>
          <td>{{ element.goodWxDailyConsp.GO }}</td>
          <td>{{ element.goodWxPer + "%" }}</td>
          <td>{{ element.goodWxDist }}</td>
          <td>{{ element.voyDuration }}</td>
          <td>{{ element.voyDistance }}</td>
          <td>{{ element.totalBunkerConsumption }}</td>
          <td>{{ element.averageDialyCon }}</td>
          <td
            [ngStyle]="{
              color:
                element.timeLost < 0
                  ? 'red'
                  : element.timeLost > 0
                  ? 'green'
                  : 'inherit'
            }"
          >
            {{ element.timeLost }}
          </td>
          <td
            [ngStyle]="{
              color:
                element.bunkerLostOrGain.HSFO < 0
                  ? 'red'
                  : element.bunkerLostOrGain.HSFO > 0
                  ? 'green'
                  : 'inherit'
            }"
          >
            {{ element.bunkerLostOrGain.HSFO }}
          </td>
          <td
            [ngStyle]="{
              color:
                element.bunkerLostOrGain.VLSFO < 0
                  ? 'red'
                  : element.bunkerLostOrGain.VLSFO > 0
                  ? 'green'
                  : 'inherit'
            }"
          >
            {{ element.bunkerLostOrGain.VLSFO }}
          </td>
          <td
            [ngStyle]="{
              color:
                element.bunkerLostOrGain.GO < 0
                  ? 'red'
                  : element.bunkerLostOrGain.GO > 0
                  ? 'green'
                  : 'inherit'
            }"
          >
            {{ element.bunkerLostOrGain.GO }}
          </td>
          <td>
            <ng-container
              *ngIf="
                editedRowIndex !== rowIndex || editedColumnName !== 'dailyHire'
              "
            >
              {{ element.claimEst.hire }}
              <button mat-icon-button (click)="editCell(rowIndex, 'dailyHire')">
                <mat-icon class="edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="
                editedRowIndex === rowIndex && editedColumnName === 'dailyHire'
              "
            >
              <input
                type="number"
                [(ngModel)]="element.claimEst.hire"
                (focusout)="exitEdit()"
              />
            </ng-container>
          </td>
          <td>
            <ng-container
              *ngIf="
                editedRowIndex !== rowIndex ||
                editedColumnName !== 'avgBunkerPrice'
              "
            >
              {{ element.claimEst.bunkPrice }}
              <button
                mat-icon-button
                (click)="editCell(rowIndex, 'avgBunkerPrice')"
              >
                <mat-icon class="edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="
                editedRowIndex === rowIndex &&
                editedColumnName === 'avgBunkerPrice'
              "
            >
              <input
                type="number"
                [(ngModel)]="element.claimEst.bunkPrice"
                (focusout)="exitEdit()"
              />
            </ng-container>
          </td>
          <td>
            {{ calculateClaimableAmount(element) }}
          </td>
          <td>
            <button mat-icon-button (click)="downloadIcon(element)">
              <mat-icon>download</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator
    [length]="elements?.length"
    [pageSizeOptions]="[15]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  <br />
  <div class="text-right">
    <button class="btn btn-light hover-button back" (click)="backClick()">
      <mat-icon>keyboard_backspace</mat-icon>&nbsp; Back To Fleet View
    </button>
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Download
    </button>
    <button class="btn btn-light hover-button mail" (click)="printTable()">
      <mat-icon>print</mat-icon>&nbsp; Print
    </button>
    <button class="btn btn-light hover-button mail" (click)="exportClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>
  <br />
</div>
